import type { Store } from '@libs/common-node';
import { client } from '../../client';
import { CWEA_ENDPOINTS } from '../../constants';
import type { GetStoreByIdParams } from '../../types/stores';

export async function getStoreById({ storeId }: GetStoreByIdParams) {
    const url = CWEA_ENDPOINTS.stores.getStoreById(storeId);
    return await client.cwea<Store | null>(url, {
        method: 'GET',
    });
}
